import '../styles/download-button.scss'

const DownloadButton = ({ parent = '', file = '#', label }) => {
    const classNames = 'download-indigo-attachment'
    return (
        <span className={`btn-container ${classNames} ${parent}`}>
            <a className={`btn btn-outline ${classNames} ${parent}`} href={file} target="_blank">
                <i />
                {label}
            </a>
        </span>
    )
}

export default DownloadButton
